import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioCapsule71 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE_71: TIdToPageConfigMap = {
  [PageIdStylioCapsule71.SUBSCRIPTIONS_CAPSULE_71]: {
    id: PageIdStylioCapsule71.SUBSCRIPTIONS_CAPSULE_71,
  },
  [PageIdStylioCapsule71.SUB_UPSELL_CAPSULE_71]: {
    id: PageIdStylioCapsule71.SUB_UPSELL_CAPSULE_71,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule71.FACE_STYLING_PDF_UPSELL_CAPSULE_71]: {
    id: PageIdStylioCapsule71.FACE_STYLING_PDF_UPSELL_CAPSULE_71,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule71.PROPORTIONS_PDF_UPSELL_CAPSULE_71]: {
    id: PageIdStylioCapsule71.PROPORTIONS_PDF_UPSELL_CAPSULE_71,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule71.DOWNLOAD_CAPSULE_71]: {
    id: PageIdStylioCapsule71.DOWNLOAD_CAPSULE_71,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
